import {
    createRegisterableComponentWithData,
    ePaperReadersAlsoLoveDataDefinationLoader,
} from '@news-mono/web-common'
import React from 'react'
import { ReadersAlsoLove } from './ReadersAlsoLove'

export const ePaperPageReadersAlsoLoveRegistration =
    createRegisterableComponentWithData(
        'epaper-page-readers-also-love',
        ePaperReadersAlsoLoveDataDefinationLoader,
        (props: { border?: boolean }, data, services) => {
            if (data.loaded) {
                return (
                    <ReadersAlsoLove
                        allEditions={data.result.issues}
                        border={props.border}
                    />
                )
            }
            return null
        },
    )
